import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              韩漫屋
            </h3>
            <p className="text-background-50/70 text-sm leading-relaxed">
              韩漫屋提供无遮韩国免费漫画大全，支持完整的免费在线阅读服务，资源齐全无删减，满足您的所有阅读需求。
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-sm">漫画分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-sm">热门推荐</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/comic/2" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  剑与魔法之巅
                </Link>
              </li>
              <li>
                <Link to="/comic/6" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  王朝之光
                </Link>
              </li>
              <li>
                <Link to="/comic/1" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  秘密恋爱手册
                </Link>
              </li>
              <li>
                <Link to="/comic/3" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  暗夜追踪者
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-sm">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/50 text-xs">
            &copy; {new Date().getFullYear()} 韩漫屋 - 无遮韩国免费漫画大全。本站所有资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/50 hover:text-background-50 text-xs transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 text-xs transition-colors cursor-pointer" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}